// extracted by mini-css-extract-plugin
module.exports = {"bb-map-with-countries__content":"bb-map-with-countries__content__oZuFe","bb-map-with-countries":"bb-map-with-countries__aBNIw"};